import { render, staticRenderFns } from "./SliInventoryCard.vue?vue&type=template&id=7f1ff119&scoped=true"
import script from "./SliInventoryCard.vue?vue&type=script&lang=js"
export * from "./SliInventoryCard.vue?vue&type=script&lang=js"
import style0 from "./SliInventoryCard.vue?vue&type=style&index=0&id=7f1ff119&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1ff119",
  null
  
)

export default component.exports